import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ComplianceService {
  TEMPLATE_BASE_PATH = '/templates';
  DOCUMENT_BASE_PATH = '/documents';
  FLOW_BASE_PATH = '/flows';

  constructor(private http: HttpService) { }

  // TEMPLATES
  getTemplates(params: object = {}): Observable<any> {
    return this.http.get(`${this.TEMPLATE_BASE_PATH}`, params);
  }

  getTemplateByFormId(formId): Observable<any> {
    return this.http.get(`${this.TEMPLATE_BASE_PATH}/${formId}`);
  }

  updateTemplateByFormId(formId, body: object = {}): Observable<any> {
    return this.http.patch(`${this.TEMPLATE_BASE_PATH}/${formId}`, body);
  }

  // DOCUMENTS
  getDocuments(params: object = {}): Observable<any> {
    return this.http.get(`${this.DOCUMENT_BASE_PATH}`, params);
  }

  getDocumentById(id): Observable<any> {
    return this.http.get(`${this.DOCUMENT_BASE_PATH}/${id}`);
  }

  updateDocumentById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.DOCUMENT_BASE_PATH}/${id}`, body);
  }

  overrideDocumentById(id, body: object = {}): Observable<any> {
    return this.http.post(`${this.DOCUMENT_BASE_PATH}/${id}/override`, body);
  }

  updateDocumentValidateById(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.DOCUMENT_BASE_PATH}/${id}/validate`, body);
  }

  // FLOWS
  getFlows(params: object = {}): Observable<any> {
    return this.http.get(`${this.FLOW_BASE_PATH}`, params);
  }

  deleteFlow(id: number): Observable<any> {
    return this.http.delete(`${this.FLOW_BASE_PATH}/${id}`);
  }

  getFlowById(id, params): Observable<any> {
    return this.http.get(`${this.FLOW_BASE_PATH}/${id}`, params);
  }

  upsertFlowInfo(body: object = {}): Observable<any> {
    return this.http.put(`${this.FLOW_BASE_PATH}`, body);
  }
}
